import {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {updateBlock} from '../../../store/actions/blockActions';
import {getBlockSelector} from '../../../store/reducers/blockReducer';
import {getValidName} from '../utils';

export function useUpdateBlockVerboseName(
  uid: string | undefined,
  readOnly: boolean = false
): any {
  const block = useSelector(getBlockSelector(uid as string));
  const dispatch = useDispatch();

  const updateBlockFn = useCallback((uid: string, newBlock: any) => {
    dispatch(updateBlock(uid, newBlock));
  }, []);

  const updateBlockVerboseName = (value: string) => {
    if (!uid || readOnly) {
      return;
    }

    let newBlock: any = {
      verbose_name: value,
      name: getValidName(value) || block?.name as string || '',
    };
    updateBlockFn(uid, newBlock);
  };

  return {
    value: block?.verbose_name || '',
    updateBlockVerboseName,
  };
}
